/* eslint-disable */
import CryptoJS from 'crypto-js'

const Utils = (function () {
	const getAgentVersion = function (version) {
		if (version) {
			let firstVersionNum = version.split('-')[0]
			return firstVersionNum
		}
	}
	const getBackAgentVersion = function (version) {
		if (version) {
			let firstVersionNum = version.split('-')[0]
			let secondVersionNum = version.split('-')[1]
			if (secondVersionNum) {
				return `${firstVersionNum}-${secondVersionNum}`
			} else {
				return firstVersionNum
			}
		}
	}

	const isNeedUpdate = function (oldVersion, newVersion) {
		if (oldVersion && newVersion) {
			let oldV = oldVersion.split('-')[0]
			let newV = newVersion.split('-')[0]
			let oldArr = oldV.split('.')
			let newArr = newV.split('.')
			return oldArr.some((i, index) => parseInt(i) < parseInt(newArr[index]))
			/* 
			if (oldArr.length < newArr.length || (oldArr.length === 1 && newArr.length === 1 && oldArr[0] < newArr[0])) {
				return true
			} else {
				if (oldArr[0] < newArr[0]) {
					return true
				} else if (parseInt(oldArr[1]) < parseInt(newArr[1])) {
					return true
				}
			}
			return false */
		}
	}

	// 脱敏函数
	const hideStr = function (str) {
		if (!str) return
		const lg = str.length
		if (lg && lg > 0) {
			if (lg == 1) {
				return '*'
			} else if (lg > 1 && lg <= 3) {
				return plusXing(str, 0, 1)
			} else if (lg > 3 && lg <= 5) {
				return plusXing(str, 1, 2)
			} else if (lg > 5 && lg <= 8) {
				return plusXing(str, 2, 2)
			} else {
				return plusXing(str, 4, 2)
			}
		} else {
			return '-'
		}
	}
	const plusXing = (str, frontLen, endLen) => {
		var len = str.length - frontLen - endLen
		var xing = ''
		for (var i = 0; i < len; i++) {
			xing += '*'
		}
		return str.substring(0, frontLen) + xing + str.substring(str.length - endLen)
	}

	const isOnMobile = function () {
		var sUserAgent = navigator.userAgent.toLowerCase()
		var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
		var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
		var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
		var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
		var bIsAndroid = sUserAgent.match(/android/i) == 'android'
		var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
		var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
		if (bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
			return true
		}
		return false
	}

	// AEC加密

	const dataConvert = (string) => {
		let d = CryptoJS.MD5(CryptoJS.enc.Utf8.parse(string)).toString().substring(8, 24)
		return d
	}
	const encryptAesCbc = (string, key, iv) => {
		const keyWA = CryptoJS.enc.Utf8.parse(dataConvert(key))
		const ivWA = CryptoJS.enc.Utf8.parse(dataConvert(iv))
		const dataWA = CryptoJS.enc.Utf8.parse(string)
		// AES-CBC 加密，PKCS7 填充
		const encrypted = CryptoJS.AES.encrypt(dataWA, keyWA, {
			iv: ivWA,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		})

		// 转 Base64
		return encrypted.toString()
	}

	// 过滤ANSI转义序列（终端控制字符）
	const filterAnsiEscapeCodes = (str) => {
		if (!str) return '暂无日志内容'
		// 1. 匹配ANSI转义序列（光标移动/颜色/清屏等，保留换行/制表符）
		const ansiRegex = /\x1B(?:[@-Z\\-_]|\[[0-?]*[ -/]*[@-~])/g
		// 2. 匹配非打印控制字符（排除\n \r \t）
		const controlCharsRegex = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g

		return str
			.replace(ansiRegex, '') // 过滤ANSI终端指令（如[K[A）
			.replace(controlCharsRegex, '') // 过滤不可见控制字符（保留换行/制表符）
			.replace(/\r\n/g, '\n') // 统一换行符为\n（兼容Windows/Mac/Linux）
			.trimStart() // 仅去除开头空白，保留内容内的换行/空格
	}

	// 获取url中的参数
	const getUrlParams = () => {
		const params = {}
		// 1. 提取 URL 中的查询字符串（兼容 hash 模式和普通模式）
		let searchStr = window.location.search // 普通模式：?way=mysql...
		if (!searchStr && window.location.hash) {
			// hash 模式：从 # 后的内容中提取 ? 部分
			const hash = window.location.hash
			const hashSearchIndex = hash.indexOf('?')
			if (hashSearchIndex > -1) {
				searchStr = hash.substring(hashSearchIndex)
			}
		}

		// 2. 解析查询字符串为对象
		if (searchStr) {
			// 去掉开头的 ?
			const search = searchStr.substring(1)
			// 按 & 分割，遍历解析每个参数
			search.split('&').forEach((item) => {
				const [key, value] = item.split('=')
				if (key && value) {
					params[key] = decodeURIComponent(value) // 解码特殊字符（如空格、中文）
				}
			})
		}
		return params
	}

	const utils = {
		getAgentVersion(version) {
			return getAgentVersion(version)
		},
		getBackAgentVersion(version) {
			return getBackAgentVersion(version)
		},
		isNeedUpdate(oldVersion, newVersion) {
			return isNeedUpdate(oldVersion, newVersion)
		},
		isOnMobile() {
			return isOnMobile()
		},
		hideStr(str) {
			return hideStr(str)
		},
		encryptAesCbc(string, key, iv) {
			return encryptAesCbc(string, key, iv)
		},
		filterAnsiEscapeCodes(str) {
			return filterAnsiEscapeCodes(str)
		},
		getUrlParams() {
			return getUrlParams()
		},
	}
	return utils
})()
export default {
	Utils,
}



// WEBPACK FOOTER //
// ./src/Utils.js